import React from 'react';
import { cn } from '../ui/cn';

/**
 * Inline app mark: navy rounded square, teal house outline with a rising trend line.
 * Same artwork as public/icon.svg so the in-app brand matches the installed icon.
 */
const BrandMark = ({ className, size = 36, rounded = true }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    role="img"
    aria-label="BZ-Tracker"
    className={cn('flex-shrink-0', className)}
  >
    <rect width="64" height="64" rx={rounded ? 16 : 0} fill="#0F2B36" />
    <path
      d="M14 30.5 32 15l10.5 9"
      fill="none"
      stroke="#14D3B0"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 29v18h30V36"
      fill="none"
      stroke="#14D3B0"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 44l10-8 8 4 13-13"
      fill="none"
      stroke="#2EF2C6"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M42 27h6v6" fill="none" stroke="#2EF2C6" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="27" cy="36" r="3" fill="#2EF2C6" />
    <circle cx="35" cy="40" r="3" fill="#2EF2C6" />
  </svg>
);

export default BrandMark;
